"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _utils.withStyles;
  }
});
exports.default = void 0;

var _webfontloader = _interopRequireDefault(require("webfontloader"));

var _Tree = _interopRequireDefault(require("./components/tree/Tree"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Tree.default;
exports.default = _default;

_webfontloader.default.load({
  google: {
    families: ['Open Sans:300,400,700', 'sans-serif']
  }
});